export const getAnalyticsBaseUrl = (
  value: string | undefined,
): string | null => {
  if (!value?.trim()) return null;

  let url: URL;
  try {
    url = new URL(value.trim());
  } catch {
    return null;
  }
  if (
    !['https:', 'http:'].includes(url.protocol) ||
    url.username ||
    url.password ||
    url.search ||
    url.hash
  ) {
    return null;
  }
  return url.href.replace(/\/+$/, '') + '/';
};
